export default "__VITE_ASSET__Dwpkqu1Z__"